import { useQuery } from '@tanstack/react-query';
import { getCarouselData } from '../../api/carousel';

export const useCarouselData = () =>
  useQuery({
    queryKey: ['getCarouselData'],
    queryFn: getCarouselData,
  });

